/* eslint-disable no-unused-vars */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Link,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import * as _ from "lodash";

import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { ExpandMore } from "@mui/icons-material";
import Loading from "../components/Loading";
import axios from "../../CustomAxios";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import moment from "moment";

function ViewProductionReport() {
  const [data, setData] = useState();
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const { production_id } = useParams();

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const snackRef = useRef(null);
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const [loader, setLoader] = useState(true);

  async function getData() {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${userData?.type}/production_report/${production_id}`,
      config
    );
    let rows = [];
    // eslint-disable-next-line

    setData(data.data);
    setLoader(false);
  }

  useEffect(() => {
    if (production_id) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [production_id]);

  function showErrorAlert(message) {
    setErr(message);
    snackRef.current.click();
  }
  const [plateMaxCtpMap, setPlateMaxCtpMap] = useState({});
  const [plateMaxBakeMap, setPlateMaxBakeMap] = useState({});

  return (
    <>
      <form noValidate autoComplete="off">
        <Button
          ref={snackRef}
          style={{ display: "none" }}
          onClick={handleClick({ vertical: "top", horizontal: "center" })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          {err ? (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          ) : success ? (
            <Alert mt={2} mb={4} severity="success">
              DPR fetched Successfully
            </Alert>
          ) : null}
        </Snackbar>
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              View Production Report
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/production-report">
                Production Report
              </Link>

              <Typography>View</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>
        {!loader ? (
          <>
            <Card mb={6}>
              <CardContent>
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5} sx={{ marginBottom: "8px" }}>
                    <Grid item xs={12} lg={12} md={12}>
                      <Typography variant="h6" gutterBottom>
                        DPR
                      </Typography>
                    </Grid>
                    {!loader && (
                      <>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="AP Company name"
                            value={data?.ap_company.name}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          md={3}
                          lg={3}
                          // sx={{ marginRight: "7.5px" }}
                        >
                          <TextField
                            size="small"
                            fullWidth
                            // sx={{ width: "100%" }}
                            // name={String(index)}
                            value={data.job_id.job_id}
                            label="Job Id"
                          />
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <TextField
                            size="small"
                            fullWidth
                            // sx={{ width: "100%" }}
                            // name={String(index)}
                            value={data.job_id.name}
                            label="Job Name"
                          />
                        </Grid>
                        <Grid item xs={12} md={2} lg={2}>
                          <TextField
                            size="small"
                            // sx={{ width: "100%" }}
                            // name={String(index)}
                            value={
                              data.plate.height +
                              "x" +
                              data.plate.width +
                              "x" +
                              data.plate.thickness
                            }
                            label="Plate Name"
                          />
                        </Grid>
                        <Grid item xs={12} md={2} lg={2}>
                          <TextField
                            size="small"
                            // sx={{ width: "100%" }}
                            // name={String(index)}
                            value={data.baking_quantity}
                            label="Bake Quantity"
                          />
                        </Grid>
                        <Grid item xs={12} md={2} lg={2}>
                          <TextField
                            size="small"
                            value={data.ctp_quantity}
                            label="CTP Quantity"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <TextField
                            size="small"
                            fullWidth
                            value={data.audit_logs[0].action_by.name}
                            label="Action by"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={6}>
                          <TextField
                            size="small"
                            fullWidth
                            value={data?.comment}
                            label="Comment"
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Paper>
              </CardContent>
            </Card>

            <Card mb={6} sx={{ marginTop: "20px" }}>
              <CardContent>
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography color="primary" variant="h6" gutterBottom>
                            Audit Logs
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid item xs={12} md={12} lg={12}></Grid>
                          <Timeline position="alternate">
                            {data.audit_logs.map((audit, ind) => {
                              return ind % 2 === 0 ? (
                                <TimelineItem>
                                  <TimelineOppositeContent
                                    align="right"
                                    variant="body2"
                                    color="secondary"
                                  >
                                    <br />

                                    {moment(audit?.timestamp).format(
                                      "MMM DD, YYYY"
                                    )}
                                    <br />
                                    {moment(
                                      audit?.audit_logs?.timestamp
                                    ).format(" hh:mm A")}
                                  </TimelineOppositeContent>
                                  <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot
                                      color="primary"
                                      variant="outlined"
                                    >
                                      {/* <FastfoodIcon /> */}
                                    </TimelineDot>
                                    <TimelineConnector />
                                  </TimelineSeparator>
                                  <TimelineContent>
                                    <Typography variant="h6" component="span">
                                      {_.upperCase(audit?.action)}
                                    </Typography>
                                    <Typography variant="body1">
                                      By-
                                      {audit?.action_by.name}
                                    </Typography>
                                    <Typography variant="caption">
                                      {audit?.description?.replaceAll(
                                        ":",
                                        "\n"
                                      )}
                                      {/* {_.upperCase(
                                         audit?.audit_logs?.user_type
                                       ) || "SUPER ADMIN"} */}
                                    </Typography>
                                  </TimelineContent>
                                </TimelineItem>
                              ) : (
                                <TimelineItem>
                                  <TimelineOppositeContent
                                    variant="body2"
                                    color="secondary"
                                  >
                                    <br />

                                    {moment(
                                      audit?.audit_logs?.timestamp
                                    ).format("MMM DD, YYYY")}
                                    <br />
                                    {moment(
                                      audit?.audit_logs?.timestamp
                                    ).format(" hh:mm A")}
                                  </TimelineOppositeContent>
                                  <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot color="primary">
                                      {/* <LaptopMacIcon /> */}
                                    </TimelineDot>
                                    <TimelineConnector />
                                  </TimelineSeparator>
                                  <TimelineContent>
                                    <Typography variant="h6" component="span">
                                      {_.upperCase(audit?.action)}
                                    </Typography>
                                    <Typography variant="body1">
                                      By- {audit?.action_by.name}
                                    </Typography>
                                    <Typography variant="caption">
                                      {audit?.description?.replaceAll(":", "\n")}
                                      {/* {_.upperCase(
                                          audit?.audit_logs?.user_type
                                        ) || "SUPER ADMIN"} */}
                                    </Typography>
                                  </TimelineContent>
                                </TimelineItem>
                              );
                            })}
                          </Timeline>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>
          </>
        ) : (
          <Loading />
        )}
      </form>
    </>
  );
}

export default ViewProductionReport;
